import React, { Fragment, useEffect } from "react";
import { useTranslation } from "react-i18next";
import SEO from "../../components/SEO/SEO";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import IndustriesSection from "../../components/Industries/Industries";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";

const IndustriesPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <SEO title="Industry Verticals" description="19 industry-specific verticals — Hotel, Restaurant, Travel, Healthcare, Education, Logistics, Real Estate, Retail, Manufacturing, and more. Purpose-built workflows." path="/industries" />
      <div className="about-page inner-page">
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <PageTitle pageTitle={t('nav.industries', { defaultValue: 'Industries' })} pagesub="Solutions" />

            <section className="pt-30 pb-30">
              <div className="container text-center ">
                <p className="opacity-75" style={{ fontSize: "1.1rem", maxWidth: 700, margin: "0 auto" }}>
                  19 industry verticals — each with dedicated modules, public storefront, customer portal, and 18 core business modules included. Pick your industry and start free.
                </p>
              </div>
            </section>

            <IndustriesSection />
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default IndustriesPage;
